
define("json!cartware_checkout/handles/cartware_checkout.json", function(){ return {
	"checkout_onepage_index": [
		"./components/checkout",
		"./components/login",
		"./components/agreements",
	    "./components/acceptance",
		"./components/coupon",
		"./components/selects",
		"./components/address/selector",
	  	"./components/address/restriction",
		"./components/ops/payment"
	]
};});

